export default function MedicineTable({ medicines, downloadQR }) {
  return (
    <div className="bg-white rounded-lg border overflow-hidden">
      <table className="min-w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="p-3 text-left">Brand</th>
            <th className="p-3 text-left">Drug</th>
            <th className="p-3 text-left">Batch</th>
            <th className="p-3 text-left">MRP</th>
            <th className="p-3 text-left">Manufacturer</th>
            <th className="p-3 text-left">Scans</th>
            <th className="p-3 text-left">QR</th>
          </tr>
        </thead>

        <tbody>
          {medicines.map((med) => (
            <tr key={med.id} className="border-t">
              <td className="p-3">{med.brand_name}</td>
              <td className="p-3">{med.drug_name}</td>
              <td className="p-3">{med.batch_no}</td>
              <td className="p-3">₹{med.mrp}</td>
              <td className="p-3">{med.manufacturer}</td>
              <td className="p-3">{med.total_scans || 0}</td>

              <td className="p-3">
                <button
                  onClick={() => downloadQR(med.qr_file_path)}
                  className="bg-indigo-600 text-white px-3 py-1 rounded"
                >
                  Download QR
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
